export const BREAKPOINTS = { mobile: 0, desktop: 1440 };
export const MQ = { xs: 0, sm: 575, md: 767, lg: 991, xl: 1199, xxl: 1399 };

export function isMobile(width: number) {
    return width <= MQ.sm;
}
